import { MotorsportsLiveScore, IMotorsportsLiveScore } from "@sky-it-livedata/livedata-sports-design-system";
import { graphql } from "appsync";

import transformQuery from "./transformers/query-transformer";
import transformSubscription from "./transformers/subscription-transformer";
import { LiveScoreQuery, LiveScoreSubscription } from "./types";
import { log } from "../../utils/log";
import { useSubscription } from "../../hooks/useSubscription";
import { WidgetContext } from "../../types/WidgetContext";
import { useIntcmp } from '../../hooks/useIntcmp';

export const setCustomAttributes = ({variables}: WidgetContext<LiveScoreQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql("subscription UpdateLiveScoreWidget($id: ID!) {\n  onUpdateLiveScoreWidgetById(id: $id) {\n    currentDay {\n      gpInfo {\n        gpPageUrl\n        gpCrosslink\n      }\n      sessions {\n        sessionDate\n        sessionName\n        sessionStatus\n        results {\n          customDriverName\n          customDriverPageUrl\n          customDriverSurname\n          customTeamName\n          customTeamPageUrl\n          fastestLap\n          firstName\n          flagUrl\n          gap\n          isFastestLap\n          lastName\n          position\n          teamName\n          timing {\n            timeHours\n            timeMilliseconds\n            timeMinutes\n            timeSeconds\n          }\n        }\n        resultsUrl\n      }\n    }\n    id\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<LiveScoreQuery>): IMotorsportsLiveScore {
    try {
        const transformedData =  transformQuery(props);
       
        if (!transformedData) {
            throw new Error('Transform query returned undefined');
        }

        return transformedData;
    } catch (error) {
        throw new Error('Transform query returned undefined');
    }
}

const ResultsContainer = ({props,
  variables,
  ...rest
}: WidgetContext<IMotorsportsLiveScore>) => {
  log({ props, variables, ...rest });
  const intCmpEventHandler = useIntcmp();

  const updatedProps = useSubscription<
    IMotorsportsLiveScore,
    LiveScoreSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    //@ts-ignorets-ignore
    transform: transformSubscription,
    mergeData: true,
  });

  return (
    <div onClick={intCmpEventHandler}>
      <MotorsportsLiveScore {...updatedProps}/>
    </div>
  ) 
    
}

export default ResultsContainer;